// extracted by mini-css-extract-plugin
export default {"trailer_player":"TrailerPlayer_trailer_player__497Zy"};